/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { themeOpts as baseTheme } from '@mayoral/ui/theme/boston';
import { createTheme } from '@mui/material';

const theme = createTheme({
  ...baseTheme,
});

export default theme;
